import { render, staticRenderFns } from "./TeamMobileView.vue?vue&type=template&id=20564143&scoped=true&"
import script from "./TeamMobileView.vue?vue&type=script&lang=js&"
export * from "./TeamMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20564143",
  null
  
)

export default component.exports